/* eslint-disable no-unused-vars */
/* global yaCounter62313592 */
import scrollDepth from 'scroll-depth';
// import router from './router';
import helpers from '../helpers';

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
	}

	if (window.yaCounter62313592) {
		yaCounter62313592.hit(path);
	}
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});
const clienLinks = ['kp.ru'];

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
}

function setEvent(selector, name, callback) {
	let $element = helpers.$document;

	let delegatedSelector = null;

	if (typeof selector === 'object') {
		if (typeof selector[0] !== 'undefined') {
			$element = $(selector[0]);
		}

		if (typeof selector[1] !== 'undefined') {
			delegatedSelector = selector[1];
		}
	} else if (typeof selector !== 'undefined') {
		$element = $(selector);
	}

	if (typeof selector !== 'object' && typeof selector === 'undefined') {
		name = `analytics-${name}`;
	}

	$element.on(name, delegatedSelector, callback);
}

// header

$('.header__logo').on('click', () => {
	ga('send', 'event', 'nav', 'kp logo header');
});

helpers.$document
	.on('analytics-test-start', () => {
		ga('send', 'event', 'test', 'start', '', {nonInteraction: true});
	})
	.on('analytics-test-question-show', (e, num, name) => {
		num = helpers.clearText(num);
		name = helpers.clearText(name).substring(0, 100);

		ga('send', 'event', 'test', `question show ${num}`, name, {nonInteraction: true});
	})
	.on('analytics-test-question-answer', (e, num, answer, name) => {
		num = helpers.clearText(num);
		name = helpers.clearText(name).substring(0, 100);

		ga('send', 'event', 'test', `question answer ${num}`, `${answer} - ${name}`);
	})
	.on('analytics-test-finish', (e, result, count) => {
		result = helpers.clearText(result).substring(0, 100);

		ga('send', 'event', 'test', 'finish', result, count);
	})
	.on('analytics-test-resume', () => {
		ga('send', 'event', 'test', 'resume');
	})
	.on('click', '.test__result-shareBtn', (e) => {
		const social = helpers.clearText(e.currentTarget.dataset.social);

		ga('send', 'event', 'share', 'test final share', social);
	})
	.on('click', '.test__share-button', (e) => {
		const social = helpers.clearText(e.currentTarget.dataset.social);

		ga('send', 'event', 'share', 'test share', social);
	})
	.on('mousedown touchdown', '.jx-slider', (e) => {
		const num = $(e.currentTarget).closest('.test__step').data('step');
		const name = helpers.clearText($(e.currentTarget).closest('.test__step').find('.test__text').text()).substring(0, 100);

		ga('send', 'event', 'curtain', 'interact', `${num} - ${name}`);
	});

start15SecTimeout();
